import type { ChargebackDetailOption } from '../../types/pages'

export function chargebackDetailSelectOptions(
  options: ChargebackDetailOption[],
  placeholder: string,
) {
  return (
    <>
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </>
  )
}
